import React from 'react';
import cn from 'classnames';
import {Listbox} from '@headlessui/react';
import IconSelectChevron from '../../components/icon/IconSelectChevron';

type Props = {
  value: string | React.ReactNode
  disabled?: boolean
}

export default function UIStdSelectButton({value, disabled}: Props) {
  return (
    <Listbox.Button
      className={cn(
        'cursor-pointer relative w-full rounded-md border border-gray bg-white pl-3 pr-10 py-2.5',
        'text-left focus:outline-none focus:ring-blue focus:border-blue transition ease-in-out duration-150',
        {'bg-gray-light': disabled},
      )}>
      <span className="block truncate">{value}</span>
      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <IconSelectChevron className="text-gray-dark"/>
      </span>
    </Listbox.Button>
  );
}
